module.exports = __webpack_public_path__ + "img/accept.b96fcde4.svg";